import type { IconSvgObject } from './types';

const TextSmallcapsIcon: IconSvgObject = [
  ["path", { d: "M10 18H6M8 3L8 18M2 5V4C2 3.44772 2.44772 3 3 3H13C13.5523 3 14 3.44772 14 4V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 21H16.5M18 13L18 21M14 14.5V14C14 13.4477 14.4477 13 15 13H21C21.5523 13 22 13.4477 22 14V14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TextSmallcapsIcon;
